export default __webpack_public_path__ + "static/featureSectionImg-b775ccf7fdeef971a09c9852b96378b1.png";